import React from 'react';
import type { MenuLanguage } from './types.js';

export function AudioSettings({ language, sound, music, onSoundChange, onMusicChange }: {
  language: MenuLanguage; sound: number; music: number;
  onSoundChange: (value: number) => void; onMusicChange: (value: number) => void;
}) {
  const es = language === 'es';
  const fr = language === 'fr';
  return <section className="menu-setting-group">
    <label className="menu-setting menu-slider"><span>{es ? 'Sonido' : fr ? 'Son' : 'Sound'}</span>
      <input type="range" min="0" max="1" step="0.05" value={sound}
        onChange={(event) => onSoundChange(Number(event.target.value))} />
    </label>
    <label className="menu-setting menu-slider"><span>{es ? 'Música' : fr ? 'Musique' : 'Music'}</span>
      <input type="range" min="0" max="1" step="0.05" value={music}
        onChange={(event) => onMusicChange(Number(event.target.value))} />
    </label>
  </section>;
}
